import gql from 'graphql-tag';

const QueueFragment = gql`
  fragment QueueFragment on Queue {
    __typename
    id
    instanceID
    status
    marketplace
    fixedCampaignName
    loopDelay
    cycleDuration
    lastCompletionEpoch
    logs
    priceTierID
    tiers {
      priceTierID
      name
      isOptic
    }
    version
    DEPLOYMENT_STATUS
    SERVER_STATUS
    instanceType
  }
`;

export default QueueFragment;
